import { GetOfflineVerificationEligibiltyCriteriaResp } from 'types/api/response/get-offline-verification-eligibilty-criteria-resp'

import { api } from './api'

export const getOfflineVerificationEligibilityCriteria = (catalogId: string) =>
  api.get<GetOfflineVerificationEligibiltyCriteriaResp>(
    `/offline_verification/criteria/${catalogId}`,
  )
